module.exports = __webpack_public_path__ + "img/icon-paypal.4eddb164.svg";